import React from "react";
import Theme from "@adsk/alloy-react-theme";
import { InlineValueDisplay } from "../../utils/components/InlineValueDisplay";
import {
  isDateOverdue,
  getDateStringAsDate,
  getDateStringAsDisplayText,
} from "@adsk/acc-issues-common/utils/date/dateUtils";
import type { Issue } from "@adsk/acc-issues-types";

export const DueDateDisplay = ({
  dueDate,
  closedBy,
}: {
  dueDate: Issue["dueDate"];
  closedBy: Issue["closedBy"];
}) => {
  if (!dueDate) {
    return <div>{InlineValueDisplay.EMPTY}</div>;
  }

  const isIssueClosed = !!closedBy;
  const date = getDateStringAsDate(dueDate);
  const dateView = getDateStringAsDisplayText(dueDate);

  const color =
    isDateOverdue(date) && !isIssueClosed ? Theme.colors.red500 : "inherit";

  return <div style={{ color }}>{dateView}</div>;
};
